import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  DxcBoxModule,
  DxcPasswordInputModule,
  DxcButtonModule,
  DxcSelectModule,
  DxcCheckboxModule,
  DxcDateInputModule,
  DxcDialogModule,
  DxcDropdownModule,
  DxcToggleGroupModule,
  DxcTextInputModule,
  DxcLinkModule,
  DxcRadioModule,
  DxcTextareaModule,
  DxcTableModule,
  DxcTabbedSectionModule,
  DxcPaginatorModule,
  ThemeModule,
  ThemeService,
  DxcWizardModule,
  DxcResultsetTableModule,
  DxcSpinnerModule,
  DxcSliderModule,
  DxcAccordionModule,
  DxcSwitchModule,
  DxcHeaderModule,
  DxcFooterModule,
  DxcSideNavModule,
  DxcAccordionGroupModule,
  DxcApplicationLayoutModule,
  DxcInputTextModule,
  DxcTabsModule,
  DxcFileInputModule,
  DxcAlertModule
} from '@dxc-technology/halstack-angular';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DxcPasswordInputModule,
    ThemeModule,
    DxcInputTextModule,
    DxcTextInputModule,
    DxcButtonModule,
    DxcSelectModule,
    DxcCheckboxModule,
    DxcDateInputModule,
    DxcLinkModule,
    DxcBoxModule,
    DxcDropdownModule,
    DxcToggleGroupModule,
    DxcRadioModule,
    DxcDialogModule,
    DxcTableModule,
    DxcTabbedSectionModule,
    DxcPaginatorModule,
    DxcWizardModule,
    DxcTextareaModule,
    DxcResultsetTableModule,
    DxcTableModule,
    DxcSpinnerModule,
    DxcAccordionModule,
    DxcSliderModule,
    DxcSwitchModule,
    DxcHeaderModule,
    DxcFooterModule,
    DxcSideNavModule,
    DxcAccordionGroupModule,
    DxcApplicationLayoutModule,
    DxcTabsModule,
    DxcFileInputModule,
    DxcAlertModule

  ],
  exports: [
    DxcPasswordInputModule,
    CommonModule,
    ThemeModule,
    DxcInputTextModule,
    DxcTextInputModule,
    DxcButtonModule,
    DxcCheckboxModule,
    DxcDateInputModule,
    DxcLinkModule,
    DxcBoxModule,
    DxcAccordionModule,
    DxcBoxModule,
    DxcDropdownModule,
    DxcToggleGroupModule,
    DxcRadioModule,
    DxcDialogModule,
    DxcTableModule,
    DxcTabbedSectionModule,
    DxcPaginatorModule,
    DxcWizardModule,
    DxcTextareaModule,
    DxcResultsetTableModule,
    DxcTableModule,
    DxcSelectModule,
    DxcSpinnerModule,
    DxcSliderModule,
    DxcSwitchModule,
    DxcHeaderModule,
    DxcFooterModule,
    DxcSideNavModule,
    DxcAccordionGroupModule,
    DxcApplicationLayoutModule,
    DxcTabsModule,
    DxcFileInputModule,
    DxcAlertModule    
  ],
  providers: [
    { provide: 'ThemeService', useClass: ThemeService }
  ],
})
export class DxcModule { }
